import { baseApi, extractData } from "../api/axiosConfig";


export const getAllContractDataPointValues = () =>
    baseApi.get("/contractDataPointValue")
        .then(extractData);


export const addContractDataPointValue = data =>
    baseApi.post("/contractDataPointValue", data)
        .then(extractData);


export const editContractDataPointValue = (contractDataPointValueId, data) =>
    baseApi.put(`/contractDataPointValue/${contractDataPointValueId}`, data)
        .then(extractData);


export const deleteContractDataPointValue = contractDataPointValueId =>
    baseApi.delete(`/contractDataPointValue/${contractDataPointValueId}`)
        .then(extractData);


export const getCDPVbyCDPid = contractDataPointId =>
    baseApi.get("/contractDataPointValue/cdpv_native", {
            params: {
                cdp_id: contractDataPointId
            }
        })
        .then(extractData);


export const getCDPVbyCDPVFid = contractDataPointValueFilterId =>
    baseApi.get("/contractDataPointValue/contractDataPointValueFilterId", {
            params: {
                contractDataPointValueFilterId
            }
        })
        .then(extractData);


export const getCDPVbyId = contractDataPointValueId =>
    baseApi.get("/contractDataPointValue/contractDataPointValueId", {
            params: {
                contractDataPointValueId
            }
        })
        .then(extractData);


export const updateExistingExpressions = myContractId =>
    baseApi.get("/contractDataPointValue/existingExpressions", {
            params: {
                my_contract_id: myContractId
            }
        })
        .then(extractData);


export const randomizeInputCdpvValues = myContractId =>
    baseApi.get("/contractDataPointValue/randomize", {
            params: {
                original_c_id: myContractId
            }
        })
        .then(extractData);


export const updateRelatedExpressions = myCdpId =>
    baseApi.get("/contractDataPointValue/relatedExpressions", {
            params: {
                my_cdp_id: myCdpId
            }
        })
        .then(extractData);


export const updateRelatedContractExpressions = myContractId =>
    baseApi.get("/contractDataPointValue/relatedContracts", {
            params: {
                my_contract_id: myContractId
            }
        })
        .then(extractData);


export const getObligationHierarchy = myProductId =>
    baseApi.get("/contractDataPointValue/obligationHierarchy", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);


export const getCalcHierarchy = (myProductId, myAttributeName) =>
    baseApi.get("/contractDataPointValue/calcHierarchy", {
            params: {
                my_product_id: myProductId,
                my_attribute_name: myAttributeName
            }
        })
        .then(extractData);

export const getCalcHierarchyBase = (myProductId, myVersionNumber, myAttributeName) =>
    baseApi
        .get("/contractDataPointValue/calcHierarchyBase", {
            params: {
                my_product_id: myProductId,
                my_version_number: myVersionNumber,
                my_attribute_name: myAttributeName
            }
        })
        .then(extractData);

export const getCalcHierarchyAddOn = (
    myCdpId,
    myHierarchy,
    myHierarchyLevel,
    maxRowId,
    myAttributeName
) =>
    baseApi
        .get("/contractDataPointValue/calcHierarchyAddOn", {
            params: {
                my_cdp_id: parseInt(myCdpId),
                my_hierarchy: myHierarchy,
                my_hierarchy_level: parseInt(myHierarchyLevel),
                max_row_id: parseInt(maxRowId),
                my_attribute_name: myAttributeName
            }
        })
        .then(extractData);

export const getOwedHierarchy = (myProductId, myVersionNumber, myAttributeName) =>
    baseApi
        .get("/contractDataPointValue/owedHierarchy", {
            params: {
                my_product_id: myProductId,
                my_version_number: myVersionNumber,
                my_attribute_name: myAttributeName
            }
        })
        .then(extractData);

export const getPaymentHierarchy = myProductId =>
    baseApi
        .get("/contractDataPointValue/paymentHierarchy", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);

export const getFringeHierarchy = myProductId =>
    baseApi
        .get("/contractDataPointValue/fringeHierarchy", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);

export const getTaxHierarchy = (myProductId, myVersionNumber, myAttributeName) =>
    baseApi
        .get("/contractDataPointValue/taxHierarchy", {
            params: {
                my_product_id: myProductId,
                my_version_number: myVersionNumber,
                my_attribute_name: myAttributeName
            }
        })
        .then(extractData);

export const getExpenseHierarchy = (myProductId, myVersionNumber, myAttributeName) =>
    baseApi
        .get("/contractDataPointValue/expenseHierarchy", {
            params: {
                my_product_id: myProductId,
                my_version_number: myVersionNumber,
                my_attribute_name: myAttributeName
            }
        })
        .then(extractData);

export const getPaymentList = myProductId =>
    baseApi
        .get("/contractDataPointValue/paymentList", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);

export const getFringeList = myProductId =>
    baseApi
        .get("/contractDataPointValue/fringeList", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);

export const getTaxList = myProductId =>
    baseApi
        .get("/contractDataPointValue/taxList", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);

export const getExpenseList = myProductId =>
    baseApi
        .get("/contractDataPointValue/expenseList", {
            params: {
                my_product_id: myProductId
            }
        })
        .then(extractData);

export const getBulkEditList = (
    seriesId,
    seasonId,
    propertyId,
    laborGroup,
    guild,
    contractId,
    contractLevel
) =>
    baseApi
        .get("/contractDataPointValue/bulkEditList", {
            params: {
                seriesId,
                seasonId,
                propertyId,
                laborGroup,
                guild,
                contractId,
                contractLevel
            }
        })
        .then(extractData);

export const getBulkEditListV2 = myContractList =>
    baseApi
        .get("/contractDataPointValue/bulkEditListV2", {
            params: {
                my_contract_list: myContractList
            }
        })
        .then(extractData);

export const applyDefault = (
    cdpvId,
    defaultValueSource,
    defaultValue,
    defaultValueValue
) =>
    baseApi
        .get("/contractDataPointValue/applyDefault", {
            params: {
                cdpv_id: cdpvId,
                default_value_source: defaultValueSource,
                default_value_variable: defaultValue.toString(),
                default_value_value: defaultValueValue
            }
        })
        .then(extractData);

export const finalizeContracts = myContractList =>
    baseApi
        .get("/contractDataPointValue/finalizeContracts", {
            params: {
                my_contract_list: myContractList
            }
        })
        .then(extractData);

export const finalizeProperty = (
    myPropertyId,
    myStatus,
    myContractType
) =>
    baseApi
        .get("/contractDataPointValue/finalizeProperty", {
            params: {
                my_property_id: Number(myPropertyId),
                my_status: myStatus,
                my_contract_type: myContractType
            }
        })
        .then(extractData);

export const evaluateUnapproved = myContractId =>
    baseApi
        .get("/contractDataPointValue/evaluateUnapproved", {
            params: {
                my_contract_id: myContractId
            }
        })
        .then(extractData);

export const getCdpvWithDefault = myCdpId =>
    baseApi
        .get("/contractDataPointValue/withDefault", {
            params: {
                my_cdp_id: myCdpId
            }
        })
        .then(extractData);

export const updateExpressionTranslationEditMode = id =>
    baseApi
        .get("/contractDataPointValue/expressionTranslationEdit", {
            params: {
                my_cdpv_id: id
            }
        })
        .then(extractData);

export const updateExpressionTranslationAddMode = () =>
    baseApi
        .get("/contractDataPointValue/expressionTranslationAdd")
        .then(extractData);

export const getCdpvPivot = (
    myAttributeId,
    myContractId,
    myVersionNumber
) =>
    baseApi
        .get("/contractDataPointValue/cdpvPivot", {
            params: {
                my_attribute_id: myAttributeId,
                my_contract_id: myContractId,
                my_version_number: myVersionNumber
            }
        })
        .then(extractData);

export const getCdpvMegaPivot = (
    myAttributeId,
    myContractId,
    myVersionNumber
) =>
    baseApi
        .get("/contractDataPointValue/cdpvMegaPivot", {
            params: {
                my_attribute_id: myAttributeId,
                my_contract_id: myContractId,
                my_version_number: myVersionNumber
            }
        })
        .then(extractData);

export const getCdpvMegaDatePivot = (
    myAttributeId,
    myContractId
) =>
    baseApi
        .get("/contractDataPointValue/cdpvMegaDatePivot", {
            params: {
                my_attribute_id: myAttributeId,
                my_contract_id: myContractId
            }
        })
        .then(extractData);

export const getDashboardPivot = myVersionNumber =>
    baseApi
        .get("/contractDataPointValue/dashboardPivot", {
            params: {
                my_version_number: myVersionNumber
            }
        })
        .then(extractData);

export const getTestScenario = myPropertyId =>
    baseApi
        .get("/contractDataPointValue/testScenario", {
            params: {
                my_property_id: myPropertyId
            }
        })
        .then(extractData);

export const getVersionInfo = myPropertyId =>
    baseApi
        .get("/contractDataPointValue/versionInfo", {
            params: {
                my_property_id: myPropertyId
            }
        })
        .then(extractData);

export const patchCdpvHelperValues = updates =>
    baseApi
        .patch("/contractDataPointValue/helperValues", updates)
        .then(extractData);


// import axios from "axios";
//
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// export const getAllContractDataPointValues = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addContractDataPointValue = abcd =>
//     axios.post(`${BASE_URL}/api/contramatic/contractDataPointValue`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const editContractDataPointValue = (selectorContractDataPointValueId, data) =>
//     axios.put(`${BASE_URL}/api/contramatic/contractDataPointValue/${selectorContractDataPointValueId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//             console.log("submitted data");
//             console.log(data);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteContractDataPointValue = selectorContractDataPointValueId =>
//     axios.delete(`${BASE_URL}/api/contramatic/contractDataPointValue/${selectorContractDataPointValueId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
// //
// // // https://stackoverflow.com/questions/48980380/returning-data-from-axios-api#48980526
// // export function getCDPVbyCDPid(contractDataPointId) {
// //     return     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/contractDataPointId`,
// //         {
// //             params: {
// //                 contractDataPointId: contractDataPointId
// //             }
// //         }).then(response => response.data)
// // // .then(console.log("this is my response"))
// // // .then(   console.log(data))
// // };
//
//
// export const getCDPVbyCDPid = (contractDataPointId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/cdpv_native`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {cdp_id: contractDataPointId}
// // export const getCDPVbyCDPid = (contractDataPointId) =>
// //     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/contractDataPointId`,
// //         {
// //             params: {contractDataPointId: contractDataPointId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCDPVbyCDPVFid = (contractDataPointValueFilterId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/contractDataPointValueFilterId`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractDataPointValueFilterId: contractDataPointValueFilterId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCDPVbyId = (contractDataPointValueId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/contractDataPointValueId`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {contractDataPointValueId: contractDataPointValueId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });



//
// export const updateExistingExpressions = (my_contract_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/existingExpressions`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_id: my_contract_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const randomizeInputCdpvValues = (my_contract_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/randomize`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {original_c_id: my_contract_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const updateRelatedExpressions = (my_cdp_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/relatedExpressions`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: my_cdp_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const updateRelatedContractExpressions = (my_contract_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/relatedContracts`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_id: my_contract_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });

// const qs = require('qs');

//
//
// export const getObligationHierarchy = (my_contract_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/obligationHierarchy`,{
//         params: {
//             my_contract_id: [1,2,3]
//         },
//         paramsSerializer: params => {
//             return qs.stringify(params)
//         }
//     }).then(console.log("my_contract_id",my_contract_id))
//
//         // {
//         //     params: {my_contract_id: myContractId}
//         // })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });



// export const getObligationHierarchy = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/obligationHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCalcHierarchy = (myProductId, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/calcHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId,
//                     my_attribute_name: myAttributeName}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });

//
// export const getCalcHierarchyBase = (myProductId, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/calcHierarchyBase`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId,
//                 my_attribute_name: myAttributeName}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });

//
// export const getCalcHierarchyBase = (myProductId, myVersionNumber, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/calcHierarchyBase`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId,
//                 my_version_number: myVersionNumber,
//                 my_attribute_name: myAttributeName}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCalcHierarchyAddOn = (myCdpId, myHierarchy, myHierarchyLevel,maxRowId, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/calcHierarchyAddOn`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: parseInt(myCdpId),
//                 my_hierarchy: myHierarchy,
//                 my_hierarchy_level: parseInt(myHierarchyLevel),
//                 max_row_id: parseInt(maxRowId),
//                 my_attribute_name: myAttributeName
//             }
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getOwedHierarchy = (myProductId, myVersionNumber, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/owedHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId,
//                 my_version_number: myVersionNumber,
//                 my_attribute_name: myAttributeName
//                     }
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getPaymentHierarchy = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/paymentHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getFringeHierarchy = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/fringeHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getTaxHierarchy = (myProductId, myVersionNumber, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/taxHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId,
//                 my_version_number: myVersionNumber,
//             my_attribute_name: myAttributeName}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const getExpenseHierarchy = (myProductId, myVersionNumber, myAttributeName) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/expenseHierarchy`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId,
//                 my_version_number: myVersionNumber,
//             my_attribute_name: myAttributeName}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getPaymentList = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/paymentList`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getFringeList = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/fringeList`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getTaxList = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/taxList`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getExpenseList = (myProductId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/expenseList`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_product_id: myProductId}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getBulkEditList = (seriesId,seasonId,propertyId,laborGroup,guild,contractId,contractLevel) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/bulkEditList`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {seriesId: seriesId,
//                 seasonId: seasonId,
//                 propertyId: propertyId,
//                 laborGroup: laborGroup,
//                 guild: guild,
//                 contractId: contractId,
//                 contractLevel: contractLevel
//             }
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getBulkEditListV2 = (myContractList) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/bulkEditListV2`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_list: myContractList
//             }
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const applyDefault = (cdpvId, defaultValueSource, defaultValue, defaultValueValue) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/applyDefault`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {cdpv_id: cdpvId,
//                 default_value_source: defaultValueSource,
//                 default_value_variable: defaultValue.toString(),
//                 default_value_value: defaultValueValue
//             }
//
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const finalizeContracts = (myContractList) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/finalizeContracts`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_list: myContractList}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const finalizeProperty = (myPropertyId, myStatus, myContractType) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/finalizeProperty`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_property_id: Number(myPropertyId),
//                 my_status: myStatus,
//                 my_contract_type: myContractType
//             }
//
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// // export const finalizeLaborGroup = (myPropertyId, myStatus, myLaborGroup) =>
// //     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/finalizeLaborGroup`,
// //         {
// //             headers: {
// //                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
// //             },
// //             params: {
// //                 my_property_id:  Number(myPropertyId),
// //                 my_status: myStatus,
// //                 my_labor_group: myLaborGroup
// //             }
// //
// //         })
// //         //https://axios-http.com/docs/handling_errors
// //         .catch(function (error) {
// //             if (error.response) {
// //                 // The request was made and the server responded with a status code
// //                 // that falls out of the range of 2xx
// //                 console.log(error.response.data);
// //                 console.log(error.response.status);
// //                 console.log(error.response.headers);
// //             } else if (error.request) {
// //                 // The request was made but no response was received
// //                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
// //                 // http.ClientRequest in node.js
// //                 console.log(error.request);
// //             } else {
// //                 // Something happened in setting up the request that triggered an Error
// //                 console.log('Error', error.message);
// //             }
// //             console.log(error.config);
// //         });
//
// export const evaluateUnapproved = (myContractId) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/evaluateUnapproved`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_contract_id: myContractId}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpvWithDefault = (my_cdp_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/withDefault`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdp_id: my_cdp_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// export const updateExpressionTranslationEditMode = (id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/expressionTranslationEdit`,
//         {
//             params: {my_cdpv_id: id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`http://localhost:3000/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const updateExpressionTranslationAddMode = () =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/expressionTranslationAdd`)
//         // export const executeExpression = (id) =>
//         //     axios.get(`http://localhost:3000/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpvPivot = (my_attribute_id, my_contract_id, my_version_number) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/cdpvPivot`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_attribute_id: my_attribute_id,
//                 my_contract_id: my_contract_id,
//                 my_version_number: my_version_number
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpvMegaPivot = (my_attribute_id, my_contract_id, my_version_number) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/cdpvMegaPivot`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_attribute_id: my_attribute_id,
//                 my_contract_id: my_contract_id,
//                 my_version_number: my_version_number
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getCdpvMegaDatePivot = (my_attribute_id, my_contract_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/cdpvMegaDatePivot`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_attribute_id: my_attribute_id,
//                 my_contract_id: my_contract_id
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
//
// export const getDashboardPivot = ( my_version_number) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/dashboardPivot`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {
//                 my_version_number: my_version_number
//             }
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getTestScenario = (my_property_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/testScenario`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_property_id: my_property_id}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getVersionInfo = (my_property_id) =>
//     axios.get(`${BASE_URL}/api/contramatic/contractDataPointValue/versionInfo`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_property_id: my_property_id}
//         })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const patchCdpvHelperValues = (updates) => {
//     return axios.patch(
//         `${BASE_URL}/api/contramatic/contractDataPointValue/helperValues`,
//         updates
//     )
// .catch(function (error) {
//     if (error.response) {
//         // The request was made and the server responded with a status code
//         // that falls out of the range of 2xx
//         console.log(error.response.data);
//         console.log(error.response.status);
//         console.log(error.response.headers);
//     } else if (error.request) {
//         // The request was made but no response was received
//         // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//         // http.ClientRequest in node.js
//         console.log(error.request);
//     } else {
//         // Something happened in setting up the request that triggered an Error
//         console.log('Error', error.message);
//     }
//     console.log(error.config);
// })
// };